/** Foundation · Workflow — indicatore dei passi di un workflow (riusabile in tutta la GI Suite). */
import React from "react";
import { Check } from "lucide-react";

export function WorkflowStepper({ steps, current, testid = "workflow-stepper" }) {
  return (
    <ol className="flex flex-wrap items-center gap-1 text-[11px]" data-testid={testid}>
      {steps.map((s, i) => {
        const state = i < current ? "done" : i === current ? "current" : "todo";
        return (
          <li key={s.id} className="flex items-center gap-1" data-testid={`${testid}-${s.id}`} data-state={state}>
            <span className={`inline-flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-semibold transition-colors
              ${state === "done" ? "bg-emerald-600 text-white" : state === "current" ? "bg-suite-primary text-white ring-4 ring-suite-primary-light" : "bg-suite-neutral-100 text-suite-neutral-400"}`}>
              {state === "done" ? <Check size={11} /> : i + 1}
            </span>
            <span className={state === "current" ? "font-semibold text-suite-neutral-900" : "text-suite-neutral-500"}>{s.label}</span>
            {i < steps.length - 1 && <span className={`mx-1 h-px w-5 ${i < current ? "bg-emerald-500" : "bg-suite-neutral-200"}`} />}
          </li>
        );
      })}
    </ol>
  );
}

export default WorkflowStepper;
